<template>
    <div v-if="total_stats" class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout v-if="common_analytics" column :class="{'pa-4': $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.xs}">
                    <v-icon slot="divider">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1">keyboard_arrow_left</v-icon>
                            {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <v-layout
                    row wrap
                    align-center
                    justify-space-between
                    :class="{'mx-3': $vuetify.breakpoint.xs}"
                >
                    <v-flex xs12>
                        <h1 class="section-title-main my-3 font-weight-regular">
                            {{ $t("Статистика") }}
                        </h1>
                    </v-flex>
                </v-layout>
                <coursesStat :total_stats="total_stats" />
                <v-layout
                    row
                    wrap
                    align-end
                    justify-space-between
                    :class="{'mx-3 my-3': $vuetify.breakpoint.xs, 'my-5': $vuetify.breakpoint.smAndUp}"
                >
                    <v-flex md5 sm7 xs12
                            :class="{'mb-4': $vuetify.breakpoint.smAndDown,'mr-4 mb-0': $vuetify.breakpoint.smAndUp}"
                    >
                        <inputIcon v-model="search_table" class="layout row search--no-border" icon_name="search"
                                   :placeholder="$t('Поиск по разделу')"
                        />
                    </v-flex>
                    <buttonRed :disabled="export_loading" class="flex md3 sm5 xs12" :class="{'my-3': $vuetify.breakpoint.xs}"
                               @click.native="export_file"
                    >
                        {{ $t("Экспорт данных") }}
                    </buttonRed>
                    <buttonBdWhite class="flex md3 sm5 xs12" @click.native="toggle_filter()">
                        {{ showed_filter ? $t('Скрыть фильтр') : $t('Показать фильтр') }}
                    </buttonBdWhite>
                </v-layout>
                <v-layout v-if="showed_filter" class="wrap align-end justify-space-between"
                          :class="{'mx-3 mb-3': $vuetify.breakpoint.xs, 'mb-5': $vuetify.breakpoint.smAndUp}"
                >
                    <v-flex v-if="permission.users" md4 sm5
                            xs6
                            xs12 class="mb-4 align-self-center"
                    >
                        <div class="text-uppercase pb-3">{{ $t("Пользователи") }}</div>
                        <v-layout>
                            <checkbox id="internal" class="mr-4" :checked="filter_values.internal"
                                      name="users_type" @change="get_user_type($event)"
                            >{{ $t("Внутренние") }}
                            </checkbox>
                            <checkbox id="external" :checked="filter_values.external" name="users_type"
                                      @change="get_user_type($event)"
                            >{{ $t("Внешние") }}
                            </checkbox>
                        </v-layout>
                    </v-flex>
                    <v-flex v-if="permission.groups" md4 sm5
                            xs12
                            class="mb-4"
                    >
                        <v-autocomplete
                            :items="filter_company_comp"
                            solo
                            append-icon=""
                            :label="$t('Все организации')"
                            class="input"
                            :value="filter_values.company"
                            @change="get_company($event)"
                        >
                          <template #append>
                            <v-icon aria-hidden="true" translate="no">
                              expand_more
                            </v-icon>
                          </template>
                        </v-autocomplete>
                    </v-flex>
                    <v-flex v-if="permission.location" md3 sm5
                            xs12
                            class="mb-4"
                    >
                        <v-layout column>
                            <div class="text-uppercase mb-3">{{ $t("Локация") }}</div>
                            <v-autocomplete
                                :disabled="filter_values.country_iso !== 'RU'"
                                :items="filter_regions_comp"
                                solo
                                append-icon=""
                                :label="$t('Все регионы')"
                                class="input"
                                :value="filter_values.region"
                                @change="get_region($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-autocomplete>
                        </v-layout>
                    </v-flex>
                    <v-flex v-if="permission.location" md3 sm5
                            xs12
                            class="mb-4"
                    >
                        <v-layout column>
                            <v-select
                                :disabled="filter_values.country_iso !== 'RU'"
                                :items="cities"
                                solo
                                append-icon=""
                                :label="$t('Все города')"
                                class="input"
                                :value="filter_values.city"
                                @change="get_city($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-layout>
                    </v-flex>
                    <v-flex lg4 md3 sm5
                            xs12 class="mb-4 lg4-modified"
                    >
                        <v-layout column>
                            <div class="text-uppercase mb-3">{{ $t("Курсы") }}</div>
                            <v-select
                                :items="filter_courses_comp_dynamic"
                                solo
                                append-icon=""
                                :label="$t('Все курсы')"
                                class="input"
                                :value="filter_values.course"
                                @change="get_course($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-layout>
                    </v-flex>
                    <v-flex lg5 md6 sm12
                            xs12 class="mb-4"
                    >
                        <div class="text-uppercase mb-3">{{ $t("Дата/Период") }}</div>
                        <v-layout row wrap justify-space-between>
                            <datepicker ref="datafilter_from"
                                        :class="{'mb-3': $vuetify.breakpoint.xs, 'mr-3': $vuetify.breakpoint.sm }"
                                        class="flex md6 sm5 xs12" placeholder="01-01-2018"
                                        @change="get_period_start($event)"
                            />
                            <datepicker ref="datafilter_to" class="flex xs12 sm5 md6" placeholder="01-01-2018"
                                        :value="filter_values.period_finish" @change="get_period_finish($event)"
                            />
                        </v-layout>
                    </v-flex>
                    <v-flex v-if="permission.employees" md3 sm5
                            xs12
                            class="mb-4"
                    >
                        <v-layout column>
                            <div class="text-uppercase mb-3">{{ $t("Сотрудники") }}</div>
                            <v-select
                                :items="filter_user_roles_comp"
                                solo
                                append-icon=""
                                :label="$t('Все роли')"
                                class="input"
                                :value="filter_values.role"
                                @change="get_role($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-layout>
                    </v-flex>
                    <v-flex lg4 md3 sm5
                            xs12 class="mb-4 lg4-modified"
                    >
                        <v-layout column>
                            <div class="text-uppercase mb-3">{{ $t("Страны") }}</div>
                            <v-select
                                :items="filter_countries_comp"
                                solo
                                append-icon=""
                                :label="$t('Все страны')"
                                class="input"
                                :value="filter_values.country"
                                @change="get_country($event)"
                            >
                              <template #append>
                                <v-icon aria-hidden="true" translate="no">
                                  expand_more
                                </v-icon>
                              </template>
                            </v-select>
                        </v-layout>
                    </v-flex>
                    <v-flex lg5 md6 sm12
                            xs12 class="mb-4"
                    >
                        <v-layout wrap align-center justify-end>
                            <redLink class="pr-3" :class="{'flex xs12 mb-4': $vuetify.breakpoint.xs}"
                                     @click.prevent="reset_filter"
                            >{{ $t("Сбросить фильтр") }}
                            </redLink>
                            <buttonRed :class="{'flex xs12': $vuetify.breakpoint.xs}" @click.native="accept_filter">
                                {{ $t("Применить") }}
                            </buttonRed>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-tabs
                    v-model="active_tab"
                    slot="extension"
                    :slider-color="tabsColor[tab]"
                >
                    <v-tab v-if="directorate_analytics" class="wrapper-relative" href="#directorate">
                        <v-layout row wrap align-center>
                            <v-flex md2>
                                <svg v-svg
                                     symbol="directorate"
                                     size="32 32"
                                     class="icon"
                                     role="presentation"
                                />
                            </v-flex>
                            <v-flex sm12 xs12 md9
                                    :class="{'pl-0': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                            >{{ $t("Управления") }}
                            </v-flex>
                            <v-flex class="md1 study__badge">
                                <v-badge color="#e2173d">
                                    <span slot="badge">{{ total_stats.tab_count ? total_stats.tab_count.departments : 0 }}</span>
                                </v-badge>
                            </v-flex>
                        </v-layout>
                    </v-tab>
                    <v-tab v-if="organization_analytics" class="wrapper-relative" href="#organizations">
                        <v-layout row wrap align-center>
                            <v-flex md2>
                                <svg v-svg
                                     symbol="organizations"
                                     size="32 32"
                                     class="icon"
                                     role="presentation"
                                />
                            </v-flex>
                            <v-flex sm12 xs12 md9
                                    :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                            >{{ $t("Организации") }}
                            </v-flex>
                            <v-flex class="md1 study__badge">
                                <v-badge color="#84a45d">
                                    <span slot="badge">{{ total_stats.tab_count ? total_stats.tab_count.companies : 0 }}</span>
                                </v-badge>
                            </v-flex>
                        </v-layout>
                    </v-tab>
                    <v-tab v-if="users_analytics" class="wrapper-relative" href="#users">
                        <v-layout row wrap align-center>
                            <v-flex md2>
                                <svg v-svg
                                     symbol="rating_internal"
                                     size="32 32"
                                     class="icon"
                                     role="presentation"
                                />
                            </v-flex>
                            <v-flex sm12 xs12 md9
                                    :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                            >{{ $t("Пользователи") }}
                            </v-flex>
                            <v-flex class="md1 study__badge">
                                <v-badge color="#2755cf">
                                    <span slot="badge">{{ total_stats.tab_count ? total_stats.tab_count.users : 0 }}</span>
                                </v-badge>
                            </v-flex>
                        </v-layout>
                    </v-tab>
                    <v-tab v-if="courses_analytics" class="wrapper-relative" href="#courses">
                        <v-layout row wrap align-center>
                            <v-flex md2>
                                <svg v-svg
                                     symbol="courses"
                                     size="32 32"
                                     class="icon"
                                     role="presentation"
                                />
                            </v-flex>
                            <v-flex sm12 xs12 md9
                                    :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                            >{{ $t("Обучающие курсы") }}
                            </v-flex>
                            <v-flex class="md1 study__badge">
                                <v-badge color="#44b69e">
                                    <span slot="badge">{{ employee_study_courses_filtered.content.length || (total_stats.tab_count ? total_stats.tab_count.courses : 0) }}</span>
                                </v-badge>
                            </v-flex>
                        </v-layout>
                    </v-tab>
                    <v-tab class="wrapper-relative" href="#courses_summary">
                        <v-layout row wrap align-center>
                            <v-flex md2>
                                <svg v-svg
                                     symbol="courses-statistics"
                                     size="32 32"
                                     class="icon"
                                     role="presentation"
                                />
                            </v-flex>
                            <v-flex
                                sm12
                                xs12
                                md7
                                :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                            >
                                {{ $t("Статистика по курсам") }}
                            </v-flex>
                            <v-flex class="md3 study__badge">
                                <v-badge color="#e2173d">
                                    <span slot="badge">{{ total_stats.tab_count ? total_stats.tab_count.courses_summary : 0 }}</span>
                                </v-badge>
                            </v-flex>
                        </v-layout>
                    </v-tab>
                    <v-tab class="wrapper-relative max-width-100" href="#courses_verification">
                        <v-layout row wrap align-center>
                            <v-flex md2>
                                <svg v-svg
                                     symbol="courses-verification-statistics"
                                     size="32 32"
                                     class="icon"
                                     role="presentation"
                                />
                            </v-flex>
                            <v-flex
                                sm12
                                xs12
                                md8
                                :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                            >
                                {{ $t("Статистика по проверочным курсам") }}
                            </v-flex>
                            <v-flex class="md2 study__badge">
                                <v-badge color="#e2173d">
                                    <span slot="badge">{{ total_stats.tab_count ? total_stats.tab_count.courses_verification : 0 }}</span>
                                </v-badge>
                            </v-flex>
                        </v-layout>
                    </v-tab>

                    <v-tab class="wrapper-relative" href="#courses_business_plus_summary">
                    <v-layout row wrap align-center>
                      <v-flex md2>
                        <svg v-svg
                             symbol="courses-statistics"
                             size="32 32"
                             class="icon"
                             role="presentation"
                        />
                      </v-flex>
                      <v-flex
                          sm12
                          xs12
                          md7
                          :class="{'pl-0 caption': $vuetify.breakpoint.smAndDown,'pl-3': $vuetify.breakpoint.mdAndUp}"
                      >
                        {{ $t("Статистика по курсам Бизнес+") }}
                      </v-flex>
                      <v-flex class="md3 study__badge">
                        <v-badge color="#e2173d">
                          <span slot="badge">{{ total_stats.tab_count ? total_stats.tab_count.courses_business_plus_summary : 0 }}</span>
                        </v-badge>
                      </v-flex>
                    </v-layout>
                  </v-tab>

                    <v-tabs-items class=""
                                  :class="{'my-3': $vuetify.breakpoint.xs, 'my-5': $vuetify.breakpoint.smAndUp}"
                                  touchless
                    >
                        <v-layout align-start wrap>
                            <v-flex xs12 :class="{'order-md1': $vuetify.breakpoint.mdAndUp}">
                                <v-tab-item id="organizations">
                                    <dataTable :total="employee_study_org.content.pagination.total" :request="request"
                                               :table="employee_study_org" type="organizations"
                                    />
                                    <dataTablePagination :request="request" :table="employee_study_org" />
                                </v-tab-item>
                                <v-tab-item id="users">
                                    <dataTable :total="employee_study_users.content.pagination.total" :request="request"
                                               :table="employee_study_users" type="users"
                                    />
                                    <dataTablePagination :request="request" :table="employee_study_users" />
                                </v-tab-item>
                                <v-tab-item id="courses">
                                    <dataTable
                                        :disable_pagination="true"
                                        :table="employee_study_courses_filtered"
                                        type="courses"
                                    />
                                    <dataTablePagination :table="employee_study_courses_filtered" />
                                </v-tab-item>
                                <v-tab-item id="courses_summary">
                                    <dataTable
                                        :total="employee_study_courses_summary.content.pagination.total"
                                        :request="request"
                                        :table="employee_study_courses_summary"
                                        type="courses_summary"
                                    />
                                    <dataTablePagination :request="request" :table="employee_study_courses_summary" />
                                </v-tab-item>
                                <v-tab-item id="courses_verification">
                                    <dataTable
                                        :total="employee_study_courses_verification.content.pagination.total"
                                        :request="request"
                                        :table="employee_study_courses_verification"
                                        type="courses_verification"
                                    />
                                    <dataTablePagination :request="request" :table="employee_study_courses_verification" />
                                </v-tab-item>
                                <v-tab-item id="courses_business_plus_summary">
                                    <dataTable
                                        :total="businessPlusSummaryTable.content.pagination.total"
                                        :request="request"
                                        :table="businessPlusSummaryTable"
                                        type="courses_business_plus_summary"
                                    />
                                <dataTablePagination :request="request" :table="businessPlusSummaryTable" />
                              </v-tab-item>
                            </v-flex>
                        </v-layout>
                    </v-tabs-items>
                </v-tabs>
                <v-dialog :value="employee_study_modal.active" persistent content-class="scrolled-dialog">
                    <employeeStudyModal v-if="employee_study_modal.active" />
                </v-dialog>
                <v-dialog :value="course_stat_modal.active" persistent content-class="scrolled-dialog">
                    <courseStatModal v-if="course_stat_modal.active" />
                </v-dialog>
            </v-layout>
            <div v-else-if="common_analytics === false" class="pa-4">{{ $t("Доступ запрещён") }}</div>
        </div>
        <FooterBlock />
    </div>
</template>

<script>
import HeaderMenu from '@/components/blocks/common/Header_menu.vue';
import UserMenu from '@/components/blocks/common/User_menu.vue';
import FooterBlock from '@/components/blocks/common/Footer.vue';
import inputIcon from '@/components/ui/inputs/typed/input_icon';
import buttonRed from '@/components/ui/buttons/button_red';
import buttonBdWhite from '@/components/ui/buttons/button_bd_white';
import checkbox from '@/components/ui/inputs/base/checkbox.vue';
import datepicker from '@/components/ui/inputs/base/datepicker.vue';
import redLink from '@/components/ui/links/styled/link_red';
import employeeStudyModal from './Employee_study_modals/Employee_study_modal';
import courseStatModal from './Employee_study_modals/Course_stat_modal';
import dataTable from './Employee_study_table';
import dataTablePagination from './Employee_study_pagination';
import coursesStat from './Employee_study_stats';
import debounce from 'lodash.debounce';

import {mapState, mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    HeaderMenu,
    UserMenu,
    FooterBlock,
    inputIcon,
    buttonRed,
    buttonBdWhite,
    checkbox,
    datepicker,
    redLink,
    employeeStudyModal,
    courseStatModal,
    dataTable,
    dataTablePagination,
    coursesStat,
  },
  data() {
    return {
      filter_values: {
        internal       : false,
        external       : false,
        lukoil         : false,
        clients        : false,
        company        : 0,
        region         : 0,
        city           : 0,
        department     : 0,
        course         : 0,
        course_required: false,
        role           : 0,
        specialization : 0,
        country        : 0,
        country_iso    : '',
        period_start   : '',
        period_finish  : '',
      },
      directorate_analytics    : null,
      organization_analytics   : null,
      users_analytics          : null,
      courses_analytics        : null,
      courses_summary_analytics: null,
      common_analytics         : '',
      request                  : {
        user_type      : [],
        company_group  : [],
        company        : 0,
        region         : 0,
        city           : 0,
        department     : 0,
        course         : 0,
        course_required: false,
        role           : 0,
        specialization : 0,
        period_start   : '',
        period_finish  : '',
        search         : '',
      },
      filter_courses   : null,
      filter_user_roles: null,
      filter_regions   : null,
      filter_company   : null,
      init_active_tab  : false,
    };
  },
  computed: {
    filter_courses_comp_dynamic() {
      if (this.active_tab === 'courses_business_plus_summary') {
        // Фильтруем только курсы Business+
        console.debug('courses_business_plus_summary');
        console.debug('stats', this.total_stats);
        return [{id: 0, text: this.$t('Все курсы')}, ...this.total_stats.filter_courses.filter(courseItem => courseItem.is_business_plus)];
      }
      // Все курсы для остальных вкладок
      return [{id: 0, text: this.$t('Все курсы')}, ...this.total_stats.filter_courses];
    },
    businessPlusSummaryTable() {
      return this.employee_study_courses_business_plus_summary;
    },
    permission() {
      return this.get_all_permissions();
    },
    showed_filter() {
      if (this.tab === 'directorate') {
        return this.showed_directorate_filter;
      } else if (this.tab === 'organizations') {
        return this.showed_org_filter;
      } else if (this.tab === 'users') {
        return this.showed_users_filter;
      } else if (this.tab === 'courses') {
        return this.showed_courses_filter;
      } else if (this.tab === 'courses_summary') {
        return this.showed_courses_summary_filter;
      } else if (this.tab === 'courses_business_plus_summary') {
        return this.showed_courses_business_plus_summary_filter;
      } else if (this.tab === 'courses_verification') {
        return this.showed_courses_verification_filter;
      }
      return false;
    },
    search_table: {
      get() {
        return this.search;
      },
      set: debounce(function($event) {
        let value = $event.target ? $event.target.value : $event;
        this.request.search = value;
        this.SET_SEARCH_GENERAL(value);

        if (this.active_tab === 'directorate') {
          return this.SET_DIRECTORATE_PAGE($event);
        } else if (this.active_tab === 'organizations') {
          this.SET_ORG_PAGE(1);
          return this.get_companies(this.get_request_params(this.employee_study_org_filtered));
        } else if (this.active_tab === 'users') {
          this.SET_USERS_PAGE(1);
          return this.get_users(this.get_request_params(this.employee_study_users_filtered));
        } else if (this.active_tab === 'courses') {
          return this.SET_COURSES_PAGE($event);
          // return this.get_courses({filter: this.request, page: this.table.content.pagination.page, perPage: this.table.content.pagination.rowsPerPage});
        } else if (this.active_tab === 'courses_summary') {
          this.SET_COURSES_SUMMARY_PAGE(1);
          this.get_courses_summary(this.get_request_params(this.employee_study_courses_summary));
        } else if (this.active_tab === 'courses_business_plus_summary') {
          this.SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE(1);
          this.get_courses_business_plus_summary(this.get_request_params(this.employee_study_courses_business_plus_summary));
        } else if (this.active_tab === 'courses_verification') {
          this.SET_COURSES_VERIFICATION_PAGE(1);
          this.get_courses_verification(this.get_request_params(this.employee_study_courses_verification));
        }
      }, 700),
    },
    ...mapState('employee_study', ['search']),
    ...mapGetters('employee_study/directorate', [
      'employee_study_directorate',
      'showed_directorate_filter',
    ]),
    ...mapGetters('employee_study/organizations', [
      'employee_study_org',
      'employee_study_org_filtered',
      'showed_org_filter',
    ]),
    ...mapGetters('employee_study/users', [
      'employee_study_users',
      'employee_study_users_filtered',
      'showed_users_filter',
    ]),
    ...mapGetters('employee_study/courses', [
      'employee_study_courses_filtered',
      'showed_courses_filter',
    ]),
    ...mapGetters('employee_study/coursesSummary', [
      'employee_study_courses_summary',
      'showed_courses_summary_filter',
    ]),
    ...mapGetters('employee_study/coursesBusinessPlusSummary', [
      'employee_study_courses_business_plus_summary',
      'showed_courses_business_plus_summary_filter',
    ]),
    ...mapGetters('employee_study/coursesVerification', [
      'employee_study_courses_verification',
      'showed_courses_verification_filter',
    ]),
    ...mapGetters('employee_study', [
      'employee_study_modal',
      'get_all_permissions',
      'course_stat_modal',
      'tab',
      'total_stats',
      'get_cities_by_region_id',
      'get_region_by_name',
      'export_url',
      'export_loading',
    ]),
    ...mapGetters('profile/user', [
      'user',
    ]),
    current_region() {
      return this.get_region_by_name(this.filter_values.region);
    },
    cities() {
      return this.get_cities_by_region_id(this.current_region ? this.current_region.id : '');
    },
    active_tab: {
      get() {
        return this.tab;
      },
      set($event) {
        let init_active_tab = this.init_active_tab;

        if (!this.init_active_tab) {
          this.init_active_tab = true;
        }

        this.SET_ACTIVE_TAB($event);

        if (init_active_tab) {
          if (this.active_tab === 'directorate') {
            return this.get_organizations(this.request);
          } else if (this.active_tab === 'organizations') {
            let table = this.employee_study_org_filtered;
            this.SET_ORG_PAGE(1);
            return this.get_companies({
              filter: {
                ...this.request,
                sort_name     : table.content.pagination.sortBy || null,
                sort_direction: table.content.pagination.descending ? 'desc' : 'asc',
              },
              page   : table.content.pagination.page,
              perPage: table.content.pagination.rowsPerPage,
            });
          } else if (this.active_tab === 'users') {
            let table = this.employee_study_users_filtered;
            this.SET_USERS_PAGE(1);
            return this.get_users({
              filter: {
                ...this.request,
                sort_name     : table.content.pagination.sortBy || null,
                sort_direction: table.content.pagination.descending ? 'desc' : 'asc',
              },
              page   : table.content.pagination.page,
              perPage: table.content.pagination.rowsPerPage,
            });
          } else if (this.active_tab === 'courses') {
            this.SET_COURSES_PAGE(1);

            return this.get_courses(this.request);
          } else if (this.active_tab === 'courses_summary') {
            const table = this.employee_study_courses_summary;

            this.SET_COURSES_SUMMARY_PAGE(1);
            this.get_courses_summary({
              filter: {
                ...this.request,
                sort_name     : table.content.pagination.sortBy || null,
                sort_direction: table.content.pagination.descending ? 'desc' : 'asc',
              },
              page         : table.content.pagination.page,
              perPage      : table.content.pagination.rowsPerPage,
              business_plus: 0,
            });
          } else if (this.active_tab === 'courses_business_plus_summary') {
            const table = this.employee_study_courses_business_plus_summary;

            this.SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE(1);
            this.get_courses_business_plus_summary({
              filter: {
                ...this.request,
                sort_name     : table.content.pagination.sortBy || null,
                sort_direction: table.content.pagination.descending ? 'desc' : 'asc',
              },
              page         : table.content.pagination.page,
              perPage      : table.content.pagination.rowsPerPage,
              business_plus: 1,
            });
          } else if (this.active_tab === 'courses_verification') {
            const table = this.employee_study_courses_verification;

            this.SET_COURSES_VERIFICATION_PAGE(1);
            this.get_courses_verification({
              filter: {
                ...this.request,
                sort_name     : table.content.pagination.sortBy || null,
                sort_direction: table.content.pagination.descending ? 'desc' : 'asc',
              },
              page   : table.content.pagination.page,
              perPage: table.content.pagination.rowsPerPage,
            });
          }
        }
      },
    },
    tabsColor() {
      return {
        directorate                  : '#e2173d',
        organizations                : '#84a45d',
        users                        : '#2755cf',
        courses                      : '#44b69e',
        courses_summary              : '#e2173d',
        courses_verification         : '#e2173d',
        courses_business_plus_summary: '#e2173d',
      };
    },
    filter_company_comp() {
      return [{id: 0, text: this.$t('Все организации')}, ...this.total_stats.filter_company];
    },
    filter_regions_comp() {
      return [{id: 0, text: this.$t('Все регионы')}, ...this.total_stats.filter_regions];
    },
    filter_courses_comp() {
      return [{id: 0, text: this.$t('Все курсы')}, ...this.total_stats.filter_courses];
    },
    filter_user_roles_comp() {
      return [{id: 0, text: this.$t('Все роли')}, ...this.total_stats.filter_user_roles];
    },
    filter_countries_comp() {
      return [{id: 0, text: this.$t('Все страны')}, ...this.total_stats.filter_countries];
    },

  },
  async mounted() {
    console.debug("mounted: employee_study_wrap");
    if (localStorage.user !== undefined) {
      this.organization_analytics = this.user.role.organization_analytics.rights.length;
      this.users_analytics = this.user.role.user_analytics.rights.length;
      this.courses_analytics = this.user.role.course_analytics.rights.length;
      this.courses_summary_analytics = this.user.role.courses_summary_analytics
          ? this.user.role.courses_summary_analytics.rights.length
          : null;
      this.common_analytics = this.user.role.common_analytics.rights.length;
    }

    this.common_analytics = this.common_analytics || false;

    await this.get_total_stats();

    this.filter_courses = [{id: 0, text: 'Все курсы'}, ...this.total_stats.filter_courses];
    this.filter_user_roles = [{id: 0, text: 'Все роли'}, ...this.total_stats.filter_user_roles];
    this.filter_regions = [{id: 0, text: 'Все регионы'}, ...this.total_stats.filter_regions];
    this.filter_company = [{id: 0, text: this.$t('Все организации')}, ...this.total_stats.filter_company];

    this.get_companies({
      filter : this.request,
      page   : this.employee_study_org_filtered.content.pagination.page,
      perPage: this.employee_study_org_filtered.content.pagination.rowsPerPage,
    });
    this.get_users({
      filter : this.request,
      page   : this.employee_study_users_filtered.content.pagination.page,
      perPage: this.employee_study_users_filtered.content.pagination.rowsPerPage,
    });
    this.get_courses_summary({
      filter : this.request,
      page   : this.employee_study_courses_summary.content.pagination.page,
      perPage: this.employee_study_courses_summary.content.pagination.rowsPerPage,
    });
    this.get_courses_business_plus_summary({
      filter : this.request,
      page   : this.employee_study_courses_business_plus_summary.content.pagination.page,
      perPage: this.employee_study_courses_business_plus_summary.content.pagination.rowsPerPage,
    });
    this.get_courses_verification({
      filter : this.request,
      page   : this.employee_study_courses_verification.content.pagination.page,
      perPage: this.employee_study_courses_verification.content.pagination.rowsPerPage,
    });
    this.get_courses(this.request);
  },
  methods: {
    ...mapMutations('employee_study', [
      'SET_ACTIVE_TAB',
      'SET_SEARCH_GENERAL',
    ]),
    ...mapMutations('employee_study/directorate', [
      'TOGGLE_DIRECTORATE_FILTER',
      'SEARCH_DIRECTORATE',
      'SET_DIRECTORATE_PAGE',
    ]),
    ...mapActions('employee_study', [
      'get_total_stats',
      'get_organizations',
      'get_users',
      'get_courses',
      'get_courses_summary',
      'get_courses_business_plus_summary',
      'get_courses_verification',
      'get_companies',
      'get_learning_stats',
      'make_export',
    ]),
    ...mapMutations('employee_study/organizations', [
      'TOGGLE_ORG_FILTER',
      'SEARCH_ORG',
      'SET_ORG_PAGE',
    ]),
    ...mapMutations('employee_study/users', [
      'TOGGLE_USERS_FILTER',
      'SEARCH_USERS',
      'SET_USERS_PAGE',
    ]),
    ...mapMutations('employee_study/courses', [
      'TOGGLE_COURSES_FILTER',
      'SEARCH_COURSES',
      'SET_COURSES_PAGE',
    ]),
    ...mapMutations('employee_study/coursesSummary', [
      'SET_COURSES_SUMMARY_PAGE',
      'TOGGLE_COURSES_SUMMARY_FILTER',
    ]),
    ...mapMutations('employee_study/coursesBusinessPlusSummary', [
      'SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE',
      'TOGGLE_COURSES_BUSINESS_PLUS_SUMMARY_FILTER',
    ]),
    ...mapMutations('employee_study/coursesVerification', [
      'SET_COURSES_VERIFICATION_PAGE',
      'TOGGLE_COURSES_VERIFICATION_FILTER',
    ]),
    toggle_filter() {
      this.TOGGLE_DIRECTORATE_FILTER();
      this.TOGGLE_ORG_FILTER();
      this.TOGGLE_USERS_FILTER();
      this.TOGGLE_COURSES_FILTER();
      this.TOGGLE_COURSES_SUMMARY_FILTER();
      this.TOGGLE_COURSES_BUSINESS_PLUS_SUMMARY_FILTER();
      this.TOGGLE_COURSES_VERIFICATION_FILTER();
    },
    get_user_type(event) {
      if (event.target) {
        if (this.request.user_type.includes(event.target.id)) {
          let index = this.request.user_type.indexOf(event.target.id);
          this.request.user_type.splice(index, 1);
          this.filter_values[event.target.id] = false;
        } else {
          this.filter_values[event.target.id] = true;
          this.request.user_type.push(event.target.id);
        }
      }
    },
    get_company(event) {
      let company = this.total_stats.filter_company.find((item) => item.text == event);
      this.filter_values.company = event;

      if (company) {
        this.request.company = company.id;
      } else {
        this.request.company = 0;
      }
    },
    get_region(event) {
      let region = this.total_stats.filter_regions.find((item) => item.text == event);
      this.filter_values.region = event;

      if (region) {
        this.request.region = region.id;
      } else {
        this.request.region = 0;
      }
    },
    get_city(event) {
      let city = this.total_stats.filter_cities.find((item) => item.text == event);
      this.filter_values.city = event;


      if (city) {
        this.request.city = city.id;
      } else {
        this.request.city = 0;
      }
    },
    get_course(event) {
      let course = this.total_stats.filter_courses.find((item) => item.text == event);
      this.filter_values.course = event;

      if (course) {
        this.request.course = course.id;
      } else {
        this.request.course = 0;
      }
    },
    get_role(event) {
      let role = this.total_stats.filter_user_roles.find((item) => item.text == event);
      this.filter_values.role = event;

      if (role) {
        this.request.role = role.id;
      } else {
        this.request.role = 0;
      }
    },
    get_country(event) {
      let country = this.total_stats.filter_countries.find((item) => item.text == event);
      this.filter_values.country = event;
      this.filter_values.country_iso = country.iso;

      if (country.iso !== 'RU') {
        this.filter_values.city = 0;
        this.filter_values.region = 0;

        this.request.city = 0;
        this.request.region = 0;
      }

      if (country) {
        this.request.country = country.id;
      } else {
        this.request.country = 0;
      }
    },
    get_period_start(event) {
      this.request.period_start = event.target.value.split(' ')[0];
      this.filter_values.period_start = event.target.value;
    },
    get_period_finish(event) {
      this.request.period_finish = event.target.value.split(' ')[0];
      this.filter_values.period_finish = event.target.value;
    },
    get_request_params(table) {
      return {
        filter: {
          ...this.request,
          sort_name     : table.content.pagination.sortBy || null,
          sort_direction: table.content.pagination.descending ? 'desc' : 'asc',
        },
        page         : table.content.pagination.page,
        perPage      : table.content.pagination.rowsPerPage,
        business_plus: table.content.business_plus,
      };
    },
    async accept_filter() {
      this.SET_ORG_PAGE(1);
      this.get_companies(this.get_request_params(this.employee_study_org_filtered));

      this.SET_USERS_PAGE(1);
      this.get_users(this.get_request_params(this.employee_study_users_filtered));

      this.SET_COURSES_SUMMARY_PAGE(1);
      this.get_courses_summary(this.get_request_params(this.employee_study_courses_summary));

      this.SET_COURSES_BUSINESS_PLUS_SUMMARY_PAGE(1);
      this.get_courses_business_plus_summary(this.get_request_params(this.employee_study_courses_business_plus_summary));

      this.SET_COURSES_VERIFICATION_PAGE(1);
      this.get_courses_verification(this.get_request_params(this.employee_study_courses_verification));

      this.get_courses(this.request);
    },
    reset_object(object) {
      for (let [key, value] of Object.entries(object)) {
        switch (Object.prototype.toString.call(value)) {
          case '[object String]':
            object[key] = '';
            break;
          case '[object Number]':
            object[key] = 0;
            break;
          case '[object Boolean]':
            object[key] = false;
            break;
          case '[object Array]':
            object[key] = [];
            break;
          default:
            object[key] = undefined;
        }
      }
    },
    reset_filter() {
      this.SET_SEARCH_GENERAL('');

      this.reset_object(this.request);
      this.reset_object(this.filter_values);

      this.$refs.datafilter_from.clear_calendar();
      this.$refs.datafilter_to.clear_calendar();

      this.accept_filter();
    },
    async export_file() {
      await this.make_export(this.request);
      let win = window.open(this.export_url.url, '_blank');
      win.focus();
    },
  },
};
</script>
